import React, { useEffect, useRef } from 'react';
import categoriasJson from '../Components/moreWorksJson.js';
import './moreworks.css';
import bgmoreworks from '../images/bgworkspage.webp';
import bgmoreworksVideo from '../images/bgVideoWorks.webp';

function MoreWorks() {
    const videoRef = useRef(null);
    
        useEffect(() => {
            const videoElement = videoRef.current;
    
            if (!videoElement) return;
    
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            videoElement.play();
                            document.body.classList.add('siteOnVideo');
                        } else {
                            videoElement.pause();
                            document.body.classList.remove('siteOnVideo');
                        }
                    });
                },
                { threshold: 0.25 } 
            );
    
            observer.observe(videoElement);
    
            return () => {
                observer.unobserve(videoElement);
            };
        }, []);
        let videoURL = `${process.env.PUBLIC_URL}/videos/index-desktop.mp4`;
        let posterURL = `${process.env.PUBLIC_URL}/videos/index-desktop.webp`;
    return (
        <>
            <section className='moreWorks' style={{ backgroundImage: `url(${bgmoreworks})` }} name='works'>
                <div className='trashWorks' style={{ backgroundImage: `url(${bgmoreworksVideo})` }}></div>
                <div className='content'>
                    <h2><span>WE</span><span>BUILD</span><span>DIGITAL<i>-</i></span></h2>
                    <div className='textoWorks'><h3>Impulsa tu Marca al Siguiente Nivel con <strong>Index®</strong></h3>
                    <p>Entendemos que las grandes empresas necesitan algo más que un proveedor: 
                        necesitan un aliado estratégico. Como expertos en diseño y desarrollo digital, ofrecemos soluciones personalizadas 
                        y de alto impacto que elevan la experiencia de tu marca y generan resultados medibles.</p></div>
                </div>
                <div id="videoIndex" className="videoIndex">
                    <video
                        ref={videoRef}
                        poster={posterURL}
                        width="400"
                        height="350"
                        muted
                        loop
                        playsInline
                    >
                        <source src={videoURL} type="video/mp4" />
                    </video>
                </div>
                <div className='gradientVideo'></div>
            </section>
            <section className='moreWorksImgs'>
                <ol>
                    {categoriasJson.map((cats, index) => {
                        const img = `${process.env.PUBLIC_URL}/images/moreworks/${cats.alt}.webp`;
                        const text = cats.texto;
                        const titulo = cats.titulo;
                        const tags = cats.tags;

                        const tagElements = tags && tags.trim() !== ""
                            ? tags.split("-").map((tag, index) => <span key={index}>{tag.trim()}</span>)
                            : null;

                        const key = `${titulo}-${index + 1}`;

                        return text.trim() === "" ? (
                            <li key={key} style={{ backgroundImage: `url(${img})` }}></li>
                        ) : (
                            <li className='moreWorksText' key={key}>
                                <div className='text'>
                                    <h4>{titulo}</h4>
                                    <p>{text}</p>
                                    <div className='tags'>
                                        {tagElements && (
                                            <div className='tags'>
                                                {tagElements}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </li>
                        );
                    })}
                </ol>
            </section>
        </>
    )
}
export default MoreWorks;